import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import '@/plugins'
import './registerServiceWorker'

var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, { offset: -50 })

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.config.devtools = process.env.NODE_ENV !== 'production'

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (
  process.env.VUE_APP_TEST === 'e2e' ||
  process.env.NODE_ENV === 'development'
) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  if (typeof window !== 'undefined') {
    window.vm = app
  }
}
